import { InfoGroup } from "#/components/InfoGroup/InfoGroup";

import { usePortfolioImpactAndGreeksController } from "./PortfolioImpactAndGreeks.controller";

export const PortfolioImpactAndGreeks: React.FC = () => {
  const { marginData, greeksData } = usePortfolioImpactAndGreeksController();

  return (
    <div className="mt-2 w-full">
      <InfoGroup variant="normal" rows={marginData} title="Portfolio Impact" />
      <InfoGroup
        isGreek
        variant="normal"
        rows={greeksData}
        showDivider={false}
        title="Portfolio Greeks"
      />
    </div>
  );
};
